import { getClient } from './client';
import {
    AudienceEntryLike,
    AudienceMapper,
    ExperienceEntryLike,
    ExperienceMapper,
    // ExperimentEntry,
} from '@ninetailed/experience.js-utils-contentful';

// For the preview widget
export async function getAllExperiences() {
    const query = {
        content_type: 'nt_experience',
        include: 1,
    };

    const client = getClient(true);

    const entries = await client.getEntries(query);
    const experiences = entries.items as unknown as ExperienceEntryLike[];

    const mappedExperiences = (experiences || [])
        .filter((entry) => ExperienceMapper.isExperienceEntry(entry))
        .map((entry) => ExperienceMapper.mapExperience(entry));

    return mappedExperiences;
}

export async function getAllAudiences() {
    const query = {
        content_type: 'nt_audience',
    };

    const client = getClient(true);
    const entries = await client.getEntries(query);
    const audiences = entries.items as unknown as AudienceEntryLike[];

    const mappedAudiences = (audiences || [])
        .filter((entry) => AudienceMapper.isAudienceEntry(entry))
        .map((entry) => AudienceMapper.mapAudience(entry))
        .map((entry) => {
            return { ...entry, name: entry?.name ?? '' };
        });

    return mappedAudiences;
}
